/**
 * Expands a clamped teaser in place, for the product cards in imported blog articles and for the
 * homepage favourites grid.
 *
 * Both carry their full description in the markup, clamped to a few lines by CSS and faded out under
 * the trigger. Expanding just drops the clamp. Each trigger keeps its href to the product page, which
 * is what happens when this script does not run.
 */
(function () {
  'use strict';

  var KINDS = [
    { text: 'hh-product-card__text', trigger: 'hh-product-card__more', expanded: 'hh-product-card__text--expanded' },
    { text: 'hh-favorites__snippet', trigger: 'hh-favorites__more', expanded: 'hh-favorites__snippet--expanded' }
  ];

  function kindFor(trigger) {
    for (var i = 0; i < KINDS.length; i++) {
      if (trigger.classList.contains(KINDS[i].trigger)) return KINDS[i];
    }
    return null;
  }

  function triggerFrom(target) {
    for (var i = 0; i < KINDS.length; i++) {
      var found = target.closest('.' + KINDS[i].trigger);
      if (found) return found;
    }
    return null;
  }

  function expand(trigger) {
    var kind = kindFor(trigger);
    if (!kind) return false;
    var text = trigger.closest('.' + kind.text);
    if (!text) return false;
    text.classList.add(kind.expanded);
    trigger.hidden = true;
    return true;
  }

  /** Hides the trigger on a card whose copy was never long enough to be clamped. */
  function hideRedundantTriggers() {
    for (var k = 0; k < KINDS.length; k++) {
      var kind = KINDS[k];
      var texts = document.querySelectorAll('.' + kind.text);
      for (var i = 0; i < texts.length; i++) {
        var text = texts[i];
        var trigger = text.querySelector('.' + kind.trigger);
        if (!trigger) continue;
        // the trigger sits in the flow of the clamped box, so measure without it
        trigger.style.display = 'none';
        var clipped = text.scrollHeight - text.clientHeight > 1;
        trigger.style.display = '';
        if (!clipped) trigger.hidden = true;
      }
    }
  }

  document.addEventListener('click', function (event) {
    var trigger = triggerFrom(event.target);
    if (!trigger) return;
    if (expand(trigger)) event.preventDefault();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    var trigger = triggerFrom(event.target);
    if (!trigger) return;
    if (expand(trigger)) event.preventDefault();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideRedundantTriggers);
  } else {
    hideRedundantTriggers();
  }
  window.addEventListener('load', hideRedundantTriggers);
})();
